/* eslint-disable no-undef */
/* eslint-disable no-sequences */
/* eslint-disable no-unused-expressions */
import Swal from 'sweetalert2'
import api from '../service/service.js'
import editIncome from '../components/modal/editIncome'
import familyTable from '../components/modal/familyTable'
export default {
  name: 'income_add',
  data () {
    return {
      family_id: '',
      address_number: '',
      dataIncome: [],
      ModalMember: false,
      showFamilyTable: false,
      send_member_id: 0,
      // moo_name: '',
      // moo_number: '',
      // district: '',
      // amphoe: '',
      // province: '',
      send_id: 0,
      send_detail: '',
      send_income: '',
      send_expenditure: '',
      send_debt: '',
      send_balance: '',
      Familylist: [],
      memberAll: [],
      select_family: '',
      popAddRound: false,
      window: {
        width: 0,
        height: 0
      },
      open: false,
      searched: '',
      listitem: [],
      datas: [],
      page: {
        page: 1,
        rowPerpage: 5
      },
      datalist: []
    }
  },
  components: {
    editIncome,
    familyTable
  },
  computed: {
    pages () {
      return this.page.rowPerpage
        ? Math.ceil(this.listFilter.length / this.page.rowPerpage)
        : 0
    },
    pagesleft () {
      if (this.page.page === 1) {
        return 0
      }
      return (this.page.page - 1) * this.page.rowPerpage
    },
    pagesright () {
      if (this.page.page === this.pages) {
        return this.listFilter.length
      } else {
        return this.page.page * this.page.rowPerpage
      }
    },
    listFilter () {
      var myNewStr = this.searched.substr(-1)
      var str = this.searched.split(' ')
      console.log(this.datalist)
      for (let i = this.datalist.length; i >= str.length; i--) {
        this.datalist.pop()
      }
      console.log(this.datalist)
      if (myNewStr === ' ') {
        this.datalist.push(this.listitem)
        console.log(this.datalist)
      }
      console.log(this.dataIncome)
      if (str.length > 1) {
        this.datas = this.datalist[str.length - 2].filter(roundAlls => {
          if (
            roundAlls.id
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.detail
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.income
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.expenditure
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.debt
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.balance
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.address_number
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase())
          ) {
            return (
              roundAlls.id
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.detail
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.income
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.expenditure
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.debt
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.balance
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.address_number
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase())
            )
          }
        })
      } else {
        this.datas = this.dataIncome.filter(roundAlls => {
          console.log(this.searched)
          if (
            roundAlls.id
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.detail
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.income
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.expenditure
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.debt
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.balance
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.address_number
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase())
          ) {
            return (
              roundAlls.id
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.detail
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.income
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.expenditure
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.debt
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.balance
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            roundAlls.address_number
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase())
            )
          }
        })
      }
      console.log(this.datas)
      if (myNewStr === ' ') {
        this.datas = this.listitem
        return this.datas
      } else {
        this.listitem = []
        this.listitem = this.datas
      }
      console.log(this.datas)
      return this.datas
    },
    widthsize () {
      if (this.window.width <= 855) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    pagechange (val) {
      this.page.page = val
    },
    pagecgange (val) {
      console.log(this.pages)
      if (val === 1) {
        if (this.page.page < this.pages) {
          this.page.page += 1
        }
      } else {
        if (this.page.page !== 1) {
          this.page.page -= 1
        }
        return 1
      }
    },
    edit (index) {
      let ds = this.listAll[index]
      ds.open = !this.listAll[index].open
      this.listAll.splice(index, 1, ds)
    },
    change (val, index) {
      val.lname = val.lname
      this.listAll[index].open = !this.listAll[index].open
      console.log(this.listAll[index].open)
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    back () {
      this.memberAll = []
      this.dataIncome = []
      this.select_family = []
      this.family_id = ''
      this.$router.push({name: 'add_income'})
    },
    familyById () {
      let payload = this.family_id
      console.log('familyById:', payload)
      api.familyById(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            this.family_id = result.data[0].family_id,
            this.address_number = result.data[0].address_number,
            this.moo_name = result.data[0].moo_name,
            this.moo_number = result.data[0].moo_number,
            this.district = result.data[0].tambon,
            this.amphoe = result.data[0].district,
            this.province = result.data[0].province
          }
        },
        error => {
          alert(error)
          console.log(error)
        })
    },
    incomeFamily () {
      this.dataIncome = []
      let payload = this.family_id
      // let payload = 1
      console.log('incomeByFamily:', this.family_id)
      api.incomeByFamily(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            console.log(result.data)
            for (var i = 0; i < result.data.length; i++) {
              this.dataIncome.push(result.data[i])
            }
          }
        },
        error => {
          alert(error)
          console.log(error)
        })
    },
    incomeDelete (val) {
      console.log('incomeid:', val.id)
      Swal.fire({
        title: 'ยืนยันการอนุมัติ?',
        text: 'เมื่อยืนยันระบบจะทำการลบข้อมูลนี้!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then(result => {
        if (result.value) {
          let payload = val.id
          api.incomeDlete(
            payload,
            result => {
              console.log(result)
              if (result.result === true) {
                this.alert_msg(
                  'success',
                  'ข้อความจากระบบ',
                  'บันทึกสำเร็จ '
                )
              }
              this.familyById()
              this.incomeFamily()
              // location.reload()
            },
            error => {
              alert(error)
              console.log(error)
            })
        }
      })
    },
    editIncomeByFam (val) {
      console.log('tag_id', val.id)
      this.send_id = val.id,
      this.send_detail = val.detail,
      this.send_income = val.income,
      this.send_expenditure = val.expenditure,
      this.send_debt = val.debt,
      this.send_balance = val.balance
      $('#Modal').modal('show')
    },
    addIncomeByFam () {
      console.log('tag_id', this.family_id)
      if (this.family_id === null) {
        Swal.fire({
          title: 'คุณไม่ได้เลือกครอบครัว?',
          text: 'กรุณาเลือกครอบครัว!',
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'ตกลง'
        })
      } else {
        this.send_id = '0',
        this.send_detail = '',
        this.send_income = '',
        this.send_expenditure = '',
        this.send_debt = '',
        this.send_balance = ''
        $('#Modal').modal('show')
      }
    },
    familyselect () {
      $('#ModalfamilyTable').modal('show')
    },
    doFuncFoo (value) {
      console.log(value)
      sessionStorage.family = JSON.stringify(value)
      this.select_family = value
      this.family_id = value.family_id
      this.familyById()
      this.incomeFamily()
      this.memberShow()
    },
    doFuncReload (value) {
      console.log('Reload', value)
      this.incomeFamily()
    },
    memberShow () {
      this.memberAll = []
      console.log('memberShow:', this.family_id)
      let payload = this.family_id
      api.memberShow(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            console.log(result.data)
            for (var i = 0; i < result.data.length; i++) {
              this.memberAll.push(result.data[i])
            }
          }
        },
        error => {
          alert(error)
          console.log(error)
        })
    },
    GetPrefix (val) {
      console.log(val)
      if (val === '1') {
        return 'นาย'
      }
      if (val === '2') {
        return 'นาง'
      }
      if (val === '3') {
        return 'นางสาว'
      }
    },
    test () {
      console.log('tag', this.family_id)
    }
  },
  mounted () {
    if (sessionStorage.family !== '') {
      this.family_id = JSON.parse(sessionStorage.family).family_id
      this.select_family = JSON.parse(sessionStorage.family)
    } else {
      this.family_id = ''
      this.select_family = []
    }
    this.familyById()
    this.incomeFamily()
    this.memberShow()
  }
}



// WEBPACK FOOTER //
// ./src/js/add_income.js